<div class="dashboard-layout">
  <div class="dashboard-content">
<app-dashboard-header></app-dashboard-header>  
  <router-outlet></router-outlet>
  </div>
</div>